import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4rdl01ab95mriqdiqlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-5">
            <h3 className="text-5xl font-thin mb-6">Stay Connected</h3>
            <p className="text-sm text-teal-100 mb-8 leading-relaxed">
              Subscribe to our newsletter for the latest updates, security tips, and exclusive offers.
            </p>
            <form onSubmit={handleSubscribe} className="space-y-4" data-readdy-form>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="w-full bg-transparent border-b border-white/50 text-white text-sm py-3 focus:border-white focus:outline-none transition-colors placeholder-white/70"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="inline-flex items-center space-x-2 bg-white text-teal-700 px-8 py-3 rounded-full text-sm font-semibold hover:bg-teal-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                <span>{isSubmitting ? 'Subscribing...' : 'Subscribe'}</span>
                <i className="ri-arrow-right-line"></i>
              </button>
              {submitStatus === 'success' && (
                <p className="text-white text-sm">Successfully subscribed!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-200 text-sm">Failed to subscribe. Please try again.</p>
              )}
            </form>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-wider text-teal-200 mb-6">NAVIGATION</p>
            <ul className="space-y-4">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-base text-white hover:text-teal-100 transition-colors underline cursor-pointer">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('security')} className="text-base text-white hover:text-teal-100 transition-colors underline cursor-pointer">
                  Security
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-base text-white hover:text-teal-100 transition-colors underline cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-base text-white hover:text-teal-100 transition-colors underline cursor-pointer">
                  Support
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-wider text-teal-200 mb-6">GET IN TOUCH</p>
            <div className="space-y-4">
              <p className="text-lg text-white">+1 8444913439</p>
              <p className="text-lg text-white underline">contact@jccabralsrl.com</p>
              <div className="pt-6">
                <p className="text-xs uppercase tracking-wider text-teal-200 mb-3">LOCATION</p>
                <p className="text-base text-teal-100 leading-relaxed">
                  JOSE MARIA URIBURU 4780<br />
                  Formosa, P3600HFR, Argentina
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="flex items-center space-x-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center hover:scale-110 transition-transform cursor-pointer">
                <i className="ri-linkedin-fill text-white text-2xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center hover:scale-110 transition-transform cursor-pointer">
                <i className="ri-twitter-x-fill text-white text-2xl"></i>
              </a>
            </div>
            <p className="text-sm text-teal-100">© 2025 J C CABRAL S.R.L. All rights reserved</p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-teal-100 hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-sm text-teal-100 hover:text-white transition-colors cursor-pointer">Terms of Service</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-teal-100 hover:text-white transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
